import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { INewName } from 'src/app/models/inewname.interface';

@Component({
  selector: 'app-rename',
  templateUrl: './rename.component.html',
  styleUrls: ['./rename.component.css']
})
export class RenameComponent implements OnInit {

  frm: UntypedFormGroup;

  isLoading: true;

  constructor(private fb: UntypedFormBuilder, public ref: DynamicDialogRef, public config: DynamicDialogConfig) { }

  ngOnInit() {
    const data = this.config.data.item as INewName;
    this.frm = this.fb.group({
      newName: new UntypedFormControl(data.name || '', Validators.required)
    });
  }

  onCancel() {
    this.ref.close();
  }

  onSubmit(f: UntypedFormGroup) {
    const data: INewName = {
      name: f.value.newName
    };
    this.ref.close(data);
  }

}
